import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    console.log("Welcome to KwanzaCare -Appointment.")
    console.log("Looking for my code? I am hiring!")

  //   console.log(" \
  //   _  __                          ___              \
  //   | |/ /_ __ ____ _ _ _  _____ _ / __|__ _ _ _ ___ \
  //   | ' <\ V  V / _` | ' \|_ / _` | (__/ _` | '_/ -_)\
  //   |_|\_\\_/\_/\__,_|_||_/__\__,_|\___\__,_|_| \___|\
  //                                                    \
  // ");

  }

}




// ____  __.                                   _________                                        
// |    |/ _|_  _  ______ _____  _____________  \_   ___ \_____ _______   ____                   
// |      < \ \/ \/ /    \\__  \ \___   /\__  \ /    \  \/\__  \\_  __ \_/ __ \                  
// |    |  \ \     /   |  \/ __ \_/    /  / __ \\     \____/ __ \|  | \/\  ___/                  
// |____|__ \ \/\_/|___|  (____  /_____ \(____  /\______  (____  /__|    \___  >                 
//         \/           \/     \/      \/     \/        \/     \/            \/                  
//             _____                       .__               __                         __    ._.
//            /  _  \ ______ ______   ____ |__| ____   _____/  |_  _____   ____   _____/  |_  | |
//   ______  /  /_\  \\____ \\____ \ /  _ \|  |/    \ /  _ \   __\/     \_/ __ \ /    \   __\ | |
//  /_____/ /    |    \  |_> >  |_> >  <_> )  |   |  (  <_> )  | |  Y Y  \  ___/|   |  \  |    \|
//          \____|__  /   __/|   __/ \____/|__|___|  /\____/|__| |__|_|  /\___  >___|  /__|    __
//                  \/|__|   |__|                  \/                  \/     \/     \/        \/

